import React, {useEffect} from 'react'
import {Box} from "@mui/material"
import {ButtonLoadingSeeker} from "@ui-seeker/core"

import {useUnmatchedNewProductsTable} from '../@hooks'
import {newProductsMultipleRowsSend, newProductsMultipleRowsSkip} from '../@signals'
import SkipMultipleButton from "./SkipMultipleButton";


export default function UnmatchedNewProductsTableToolbar({ selectedData, setSelectedRows }) {

    const { handleMultipeEditClick } = useUnmatchedNewProductsTable(selectedData)

    useEffect(() => {
        if (newProductsMultipleRowsSend.value.length) {
            setSelectedRows([])
            newProductsMultipleRowsSend.value = []
        }
    }, [newProductsMultipleRowsSend.value])

    return <Box sx={{display: "flex", alignItems: "center", justifyContent: "flex-end", mr: 2.5}}>
        <SkipMultipleButton onClick={() => newProductsMultipleRowsSkip.value = selectedData}/>
        <ButtonLoadingSeeker
            icon="trash"
            tooltip="Edit multiple mappings"
            onClick={handleMultipeEditClick}
        >
            Edit Multiple
        </ButtonLoadingSeeker>
    </Box>
}